export const CREATE_TIKKIE = 'app/PaymentRequestCreateContainer/CREATE_TIKKIE';
export const CREATE_TIKKIE_SUCCESS =
  'app/PaymentRequestCreateContainer/CREATE_TIKKIE_SUCCESS';
export const CREATE_TIKKIE_ERROR =
  'app/PaymentRequestCreateContainer/CREATE_TIKKIE_ERROR';
